export default __webpack_public_path__ + "static/media/Aura-Egg__43.8fc275f9.png";